var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgOsWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.997 7.596H8l-.007-4.56c0-.092.03-.116.114-.128 1.17-.168 1.95-.34 3.121-.51l2.734-.397c.01-.002.019 0 .036 0v5.595Zm-6.855.81v4.59c-.086-.01-3.168-.386-4.456-.563l-.605-.08c-.05-.006-.081-.018-.081-.082q.002-1.919.002-3.836c0-.007.002-.012.006-.029zm.857 4.697V8.406h5.998v5.596c-2.129-.3-3.863-.598-5.998-.899m-.858-10.06V7.59H2.006V3.693c1.593-.216 3.533-.432 5.135-.65",
    clipRule: "evenodd"
  })));
});